(function () {
    'use strict';

    angular.module('elogbooks.user.duty-management', []);
})();
